import PropTypes from "prop-types"

/** This is the definition for the prop type to be passed into the LocationPicker component */
const LocationTreeShape = {
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
}

LocationTreeShape.children = PropTypes.arrayOf(PropTypes.shape(LocationTreeShape)).isRequired

export default LocationTreeShape



// WEBPACK FOOTER //
// ./src/state/shapes/LocationTreeShape.js